(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/collections/search-result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/collections/search-result.js');
(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.collections.SearchResult = Backbone.Collection.extend({
    initialize: function() {
      function singelSearch(model) {
        return new svs.grassroots.models.SingleSearchResult(model);
      }

      this.set(_.map(svs.grassroots.data.searchResult, singelSearch));
    }
  });
})(Backbone, _, svs);


 })(window);